
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-video-editor",
      function () {
        return require("private-next-pages/ai-video-editor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-video-editor"])
      });
    }
  